import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { PolicyTemplateDashboardPolicyTemplate } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RemoveModalTypes {
	getPolicyTemplatesData: () => Promise<void>;
	policyTemplatesData: PolicyTemplateDashboardPolicyTemplate[];
	setPolicyTemplatesData: React.Dispatch<React.SetStateAction<PolicyTemplateDashboardPolicyTemplate[]>>;
	templateId?: string;
	templateTitle?: string;
	closeModal?: closeModalType;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({
	closeModal,
	getPolicyTemplatesData,
	policyTemplatesData,
	setPolicyTemplatesData,
	templateId,
	templateTitle
}) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const removeTemplate = async () => {
		const newData = policyTemplatesData.filter((item) => item.id !== templateId);

		setPolicyTemplatesData(newData);

		const response = await apibridge.postPolicyTemplateDelete({ id: templateId });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			getPolicyTemplatesData();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove <strong> '{templateTitle}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={removeTemplate}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
